import { cn } from '@/utils/helpers';

export type PlusIconProps = {
  className?: string;
};

export function PlusIcon({ className }: PlusIconProps) {
  return (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      preserveAspectRatio="xMidYMid meet"
      className={cn('plus-icon', className)}
      aria-hidden
    >
      <path
        d="M10 4.16666V15.8333M4.16669 10H15.8334"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
